<template>
  <div class="slidecontainer">

    <input type="range" v-model="value" class="slider" id="myRange">

  </div>
</template>

<script>

  export default {
    name: 'Slider',
    data() {
      return {
        value: 100
      }
    },



  }

</script>

<style scoped>

.slidecontainer {
  width: 80%; /* Width of the outside container */
  margin: auto;
}

/* The slider itself */
.slider {
  -webkit-appearance: none;  /* Override default CSS styles */
  appearance: none;
  width: 100%; /* Full-width */
  height: 30px; /* Specified height */
  background: #ccc; /* Grey background */
  outline: none; /* Remove outline */
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.slider::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 85px;
  height: 40px;
  background: var(--primaryColor);
  cursor: pointer;
  border-radius: 5px;
}



</style>
